import type { ChainId } from '@morpho-org/blue-sdk'
import type { Chain } from 'viem'

import { InterfaceChainUtils } from '@morpho-org/dapp-core'
import { chains, ChainId as Web3ChainId } from '@repo/web3/configs'

import { clientEnvs } from './client-envs'

const defaultChain = chains[Web3ChainId.Mainnet]

const availableChainIds = clientEnvs.NEXT_PUBLIC_AVAILABLE_CHAINS.filter(chainId =>
  InterfaceChainUtils.isDeployedOnChain.id(chainId)
)

// oxlint-disable-next-line typescript/consistent-type-assertions
const availableChains = availableChainIds.map(chainId => {
  return InterfaceChainUtils.getMetadata(chainId).chain
}) as unknown as [Chain, ...Chain[]]

export const ChainConfig = {
  /**
   * The default chain of the application
   */
  DEFAULT_CHAIN: defaultChain,
  /**
   * The available chain IDs
   */
  AVAILABLE_CHAIN_IDS: availableChainIds,

  /**
   * The available chains as an array of chains
   */
  AVAILABLE_CHAINS: availableChains,

  INTERFACE_CHAINS: availableChains.map(chain => InterfaceChainUtils.getMetadata(chain.id)),

  /**
   * Check if a chain is available in the client environment. Accepts an
   * arbitrary number so untrusted input (e.g. parsed request payloads) can be
   * narrowed to `ChainId` without an upstream cast.
   * @param chainId - The chain ID to check
   * @returns True if the chain is available, false otherwise
   */
  isAvailable: (chainId: number): chainId is ChainId => {
    // oxlint-disable-next-line typescript/consistent-type-assertions
    return availableChainIds.includes(chainId as ChainId)
  },

  /**
   * Get the Erpc proxy URL for a chain
   * @param chainId - The chain ID to get the Erpc proxy URL for
   * @returns The Erpc proxy URL for the chain
   */
  getErpcProxyUrl: (chainId: ChainId) => {
    return `/api/rpc/${chainId}`
  }
} as const
